export default function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


//////////////////
// WEBPACK FOOTER
// ../~/react-transition-group/~/dom-helpers/esm/hasClass.js
// module id = 3105
// module chunks = 121